/* eslint-disable react-hooks/exhaustive-deps */
import TabNav from "components/TabNav";
import { useHasRole } from "contexts/AuthContext";
import AppealToCourtModal from "pages/accusedRequests/fragments/AppealToCourtModal";
import AddAppealCouncilLitigationDecisionModal from "pages/advocateAppealRequests/fragments/AddAppealCouncilLitigationDecisionModal";
import AddAppealLitigationDecisionModal from "pages/advocateAppealRequests/fragments/AddAppealLitigationDecisionModal";
import AppealCouncilLitigationCard from "pages/advocateAppealRequests/fragments/AppealCouncilLitigationCard";
import AppealLitigationCardForCourt from "pages/advocateAppealRequests/fragments/AppealLitigationCardForCourt";
import TerminateAppealLitigationModal from "pages/advocateAppealRequests/fragments/TerminateAppealLitigationModal";
import ChargeDocumentCard from "pages/advocateComplaint/fragments/ChargeDocumentCard";
import ComplaintDetailInfoCard from "pages/advocateComplaint/fragments/ComplaintDetailInfoCard";
import DecisionCard from "pages/advocateComplaint/fragments/DecisionCard";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  fetchAdvocateComplaintById,
  fetchAppealCouncilLitigationByAppealSummonId,
  fetchAppealLitigationByAppealSummonId,
  fetchCourtAppealByComplaintId,
  fetchInvestigationByComplaintId,
} from "services/advocateComplaintService";
import {
  AdvocateComplaints,
  CouncilLitigation,
  CourtAppeal,
  Investigation,
  Litigation,
} from "types";
import {
  COMPLIANT_STATUS,
  COURT_APPEAL_STATUS,
  INVESTIGATION_STATUS,
} from "utils/constantValues";
import { ADVOCATE_ROLES, ROLES } from "utils/roles";
import { useTranslation } from "contexts/i18nContext";
import AddCourtDailyHearingModal from "./fragments/AddCourtDailyHearingModal";
import CourtSummonCard from "./fragments/CourtSummonCard";

const tabs = ["Detail Information", "Litigation"];

export default function SingleAdvocateCourtAppeal() {
  const { t } = useTranslation();
  const { uu_id } = useParams();

  const canViewCompliantDetail = useHasRole([
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
    ADVOCATE_ROLES.INSPECTION_COORDINATOR,
    ADVOCATE_ROLES.INSPECTION_DIRECTOR,
  ]);
  const canViewChargeDoc = useHasRole([
    ADVOCATE_ROLES.INSPECTION_COORDINATOR,
    ADVOCATE_ROLES.INSPECTION_DIRECTOR,
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
    ADVOCATE_ROLES.INSPECTION_REGISTRAR,
  ]);
  const canViewCourtAppeal = useHasRole([
    ADVOCATE_ROLES.INSPECTION_COORDINATOR,
    ADVOCATE_ROLES.INSPECTION_DIRECTOR,
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
    ADVOCATE_ROLES.INSPECTION_REGISTRAR,
    ROLES.INSPECTION_REGISTRAR,
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
    ADVOCATE_ROLES.ZONAL_OFFICE_OF_COUNCIL_COORDINATOR,
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  ]);
  const canCreateInspectionDailyHearing = useHasRole([
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  ]);
  // const canCreateCouncilDailyHearing = useHasRole([
  //   ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  //   ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
  //   ADVOCATE_ROLES.ZONAL_OFFICE_OF_COUNCIL_COORDINATOR,
  //   ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  // ]);
  const canCreateLitigationDecision = useHasRole([
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  ]);
  // const canCreateCouncilLitigationDecision = useHasRole([
  //   ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  //   ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
  //   ADVOCATE_ROLES.ZONAL_OFFICE_OF_COUNCIL_COORDINATOR,
  //   ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  // ]);
  // const canTerminateInspectionLitigation = useHasRole([
  //   ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  // ]);
  const canAppealToCourt = useHasRole([ADVOCATE_ROLES.INSPECTION_REGISTRAR]);

  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState("");
  const [activeTab, setActiveTab] = useState<string>(tabs[0]);
  const [isDailyHearingOpen, setIsDailyHearingOpen] = useState(false);
  const [isLitigationDecisionOpen, setIsLitigationDecisionOpen] =
    useState(false);
  const [isCouncilLitigationDecisionOpen, setIsCouncilLitigationDecisionOpen] =
    useState(false);
  const [isTerminateOpen, setIsTerminateOpen] = useState(false);
  const [isAppealCourtOpen, setIsAppealCourtOpen] = useState(false);

  const [complaintData, setComplaintData] = useState<
    AdvocateComplaints | AdvocateComplaints[]
  >();
  const [investigationData, setInvestigationData] = useState<Investigation>();
  const [allInvestigationData, setAllInvestigationData] =
    useState<Investigation[]>();
  const [courtAppealData, setCourtAppealData] = useState<CourtAppeal>();
  const [appealLitigationData, setAppealLitigationData] =
    useState<Litigation[]>();
  const [appealCouncilLitigationData, setAppealCouncilLitigationData] =
    useState<CouncilLitigation[]>();

  const loadComplaints = useCallback(async () => {
    if (!uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchAdvocateComplaintById(uu_id);
      setComplaintData(
        Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
      );
      // setError("");
    } catch (err) {
      // setError("Failed to load complaint.");
    } finally {
      // setLoading(false);
    }
  }, [uu_id]);

  const loadInvestigations = useCallback(async () => {
    if (!complaintData || !uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchInvestigationByComplaintId(uu_id);
      if (resData) {
        setAllInvestigationData(resData?.slice()?.reverse());
        setInvestigationData(
          Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
        );
        // setError("");
      }
    } catch (err) {
      // setError("Failed to load investigation.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData]);

  const loadCourtAppeal = useCallback(async () => {
    if (!complaintData || !uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchCourtAppealByComplaintId(uu_id);
      if (resData) {
        setCourtAppealData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter((obj) => obj.discipline_complain === uu_id)[0],
        );
        // setError("");
      }
    } catch (err) {
      // setError("Failed to load investigation.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData]);

  const loadAppealLitigation = useCallback(async () => {
    if (!complaintData || !courtAppealData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealLitigationByAppealSummonId(uu_id || "");
      if (resData)
        setAppealLitigationData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter((obj) => obj.appeal_to_court === courtAppealData?.id),
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData, courtAppealData]);

  const loadAppealCouncilLitigation = useCallback(async () => {
    if (!courtAppealData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealCouncilLitigationByAppealSummonId(
        courtAppealData?.id || "",
      );
      if (resData)
        setAppealCouncilLitigationData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter((obj) => obj.appeal_to_court === courtAppealData?.id),
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [courtAppealData]);

  useEffect(() => {
    loadComplaints();
  }, [uu_id]);

  useEffect(() => {
    loadInvestigations();
  }, [complaintData]);

  useEffect(() => {
    loadCourtAppeal();
  }, [complaintData]);

  useEffect(() => {
    loadAppealLitigation();
  }, [complaintData, courtAppealData]);

  useEffect(() => {
    loadAppealCouncilLitigation();
  }, [complaintData, courtAppealData]);

  return (
    <div className="min-h-screen">
      <h1 className="text-2xl font-semibold text-gray-700 flex items-center gap-2 mb-5">
        {complaintData && Array.isArray(complaintData)
          ? ""
          : complaintData?.is_on_advocate_complaint
            ? t("advocate")
            : t("paralegal")}{" "}
        {t("courtAppealDetail")}
      </h1>

      <div className="w-full flex flex-wrap items-center justify-between gap-4 mb-5">
        <TabNav active={activeTab} tabs={tabs} onSelect={setActiveTab} />

        {activeTab === tabs[0] && (
          <div className="flex gap-4">
            {canAppealToCourt && !courtAppealData && (
              <button
                className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                type="submit"
                onClick={() => setIsAppealCourtOpen(true)}
              >
                {t("appealToCourt")}
              </button>
            )}
          </div>
        )}

        {activeTab === tabs[1] && (
          <div className="flex gap-4">
            {courtAppealData?.status === COURT_APPEAL_STATUS.APPROVED &&
              canCreateInspectionDailyHearing &&
              (!appealLitigationData ||
                (appealLitigationData &&
                  !appealLitigationData[0]?.is_final_verdict_given)) && (
                //     ||
                // (canCreateCouncilDailyHearing &&
                //   (!appealCouncilLitigationData ||
                //     (appealCouncilLitigationData &&
                //       !appealCouncilLitigationData[0]
                //         ?.is_final_verdict_given)))
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsDailyHearingOpen(true)}
                >
                  {t("addDailyHearing")}
                </button>
              )}

            {canCreateLitigationDecision &&
              appealLitigationData &&
              appealLitigationData[0]?.is_final_verdict_given &&
              !appealLitigationData[0]?.council_decision_summary &&
              !appealLitigationData[0]?.council_decision && (
                // councilLitigationData &&
                // councilLitigationData[0]?.is_final_verdict_given &&
                // (councilLitigationData[0]?.council_decision_summary ||
                //   councilLitigationData[0]?.council_decision) &&
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsLitigationDecisionOpen(true)}
                >
                  {t("addAppealLitigationDecision")}
                </button>
              )}

            {/* {canCreateCouncilLitigationDecision &&
              appealCouncilLitigationData &&
              appealCouncilLitigationData[0]?.is_final_verdict_given &&
              !appealCouncilLitigationData[0]?.council_decision_summary &&
              !appealCouncilLitigationData[0]?.council_decision && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsCouncilLitigationDecisionOpen(true)}
                >
                  {t("addCouncilOfficeDecision")}
                </button>
              )} */}
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {/* Detail Info */}
        {activeTab === tabs[0] && (
          <div className="lg:col-span-2 space-y-4">
            {canViewCourtAppeal &&
              courtAppealData &&
              complaintData &&
              !Array.isArray(complaintData) && (
                <CourtSummonCard
                  compliantData={complaintData}
                  summonData={courtAppealData}
                  appealLitigationData={appealLitigationData}
                  onSummonRefresh={loadCourtAppeal}
                  onComplaintsRefresh={loadComplaints}
                />
              )}

            {investigationData &&
              complaintData &&
              !Array.isArray(complaintData) &&
              (canViewChargeDoc ||
                investigationData?.status ===
                  INVESTIGATION_STATUS.FORWARDED_TO_COUNCIL ||
                investigationData?.status ===
                  INVESTIGATION_STATUS.FORWARDED_TO_HEAD) && (
                <ChargeDocumentCard
                  investigationData={investigationData}
                  complaintData={complaintData}
                  onInvestigationRefresh={loadInvestigations}
                />
              )}

            {canViewCompliantDetail &&
              complaintData &&
              !Array.isArray(complaintData) &&
              complaintData.status !== COMPLIANT_STATUS?.PENDING && (
                <DecisionCard
                  complaintData={complaintData}
                  investigationData={investigationData}
                  allInvestigationData={allInvestigationData}
                  onInvestigationRefresh={loadInvestigations}
                />
              )}

            {canViewCompliantDetail && (
              <ComplaintDetailInfoCard
                complaintData={complaintData}
                onComplaintsRefresh={loadComplaints}
              />
            )}
          </div>
        )}

        {/* Litigation */}
        {activeTab === tabs[1] && (
          <div className="lg:col-span-2 space-y-4">
            {appealCouncilLitigationData &&
              appealCouncilLitigationData?.length > 0 && (
                <AppealCouncilLitigationCard
                  councilLitigationData={appealCouncilLitigationData}
                  onCouncilLitigationRefresh={loadAppealCouncilLitigation}
                />
              )}

            {appealLitigationData && appealLitigationData?.length > 0 && (
              <AppealLitigationCardForCourt
                fromCourt={true}
                litigationData={appealLitigationData}
                councilLitigationData={appealCouncilLitigationData || []}
                onLitigationRefresh={loadAppealLitigation}
              />
            )}
          </div>
        )}

        {/* Sidebar */}
        {activeTab === tabs[0] && (
          <div className="space-y-4">
            {/* Sidebar content can be added here if needed */}
          </div>
        )}
      </div>

      {/* /////////////////// MODAL FORMS ///////////////////  */}
      {complaintData &&
        !Array.isArray(complaintData) &&
        courtAppealData &&
        !Array.isArray(courtAppealData) && (
          <AddCourtDailyHearingModal
            isOpen={isDailyHearingOpen}
            setIsOpen={setIsDailyHearingOpen}
            summonData={courtAppealData}
            complaintData={complaintData}
            onLitigationRefresh={loadAppealLitigation}
            onCouncilLitigationRefresh={loadAppealCouncilLitigation}
          />
        )}

      {appealLitigationData &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AddAppealLitigationDecisionModal
            fromCourt={true}
            isOpen={isLitigationDecisionOpen}
            setIsOpen={setIsLitigationDecisionOpen}
            complaintData={complaintData}
            litigationData={appealLitigationData[0]}
            onRefresh={loadAppealLitigation}
          />
        )}

      {appealCouncilLitigationData &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AddAppealCouncilLitigationDecisionModal
            isOpen={isCouncilLitigationDecisionOpen}
            setIsOpen={setIsCouncilLitigationDecisionOpen}
            complaintData={complaintData}
            councilLitigationData={appealCouncilLitigationData[0]}
            onRefresh={loadAppealCouncilLitigation}
          />
        )}

      {complaintData &&
        !Array.isArray(complaintData) &&
        appealLitigationData && (
          <TerminateAppealLitigationModal
            isOpen={isTerminateOpen}
            setIsOpen={setIsTerminateOpen}
            litigationData={appealLitigationData[0]}
            complaintData={complaintData}
            onRefresh={loadAppealLitigation}
          />
        )}

      {!courtAppealData && complaintData && !Array.isArray(complaintData) && (
        <AppealToCourtModal
          isOpen={isAppealCourtOpen}
          setIsOpen={setIsAppealCourtOpen}
          complaintData={complaintData}
          onComplaintRefresh={loadComplaints}
        />
      )}
    </div>
  );
}
